'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDay$002dOf$002dWeek from "./java.time.-Day-Of-Week.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$6(evaluator$21) {
  this.LF = null;
  this.LF = evaluator$21;
}
export { $c_Lsamples_Persons$package$$anon$6 as $c_Lsamples_Persons$package$$anon$6 };
$p = $c_Lsamples_Persons$package$$anon$6.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$6;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$6() {
}
export { $h_Lsamples_Persons$package$$anon$6 as $h_Lsamples_Persons$package$$anon$6 };
$h_Lsamples_Persons$package$$anon$6.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LF.h();
  return ((v instanceof $j_java$002etime$002e$002dDay$002dOf$002dWeek.$c_Ljava_time_LocalDate) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$6, "samples.Persons$package$$anon$6", ({
  pW: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$6 as $d_Lsamples_Persons$package$$anon$6 };
